import {
  accreditationLimitIfTrial,
  allowedUserType,
  eventQuota,
  isVerifiedByCoreEvent,
  modulesRequired,
  some,
} from '../rules'

import CustomSuccessfulPayment from '../../components/accreditations/CustomSuccessfulPayment.vue'
import SuccessfulPayment from '../../components/accreditations/SuccessfulPayment.vue'
import OrganizationCreateContainer from '../../components/organizations/OrganizationCreateContainer.vue'
import OrganizationsListContainer from '../../components/organizations/OrganizationsListContainer.vue'
import OrganizationLiveEventsListContainer from '../../components/organizations/events/OrganizationLiveEventsListContainer.vue'
import OrganizationPastEventsListContainer from '../../components/organizations/events/OrganizationPastEventsListContainer.vue'
import Messages from '../../components/organizations/mailing-list/Messages.vue'
import PromoCodeInfoContainer from '../../components/organizations/promo-codes/PromoCodeInfoContainer.vue'
import PromoCodesContainer from '../../components/organizations/promo-codes/PromoCodesContainer.vue'
import OrganizationUsers from '../../components/organizations/users/organization-users.vue'
import organizationSidebar from '../../components/shared/sidebars/organization/OrganizationSidebar.vue'
import TicketStatistics from '../../components/stats/ticket-statistics-container.vue'
import TicketsCategoriesContainer from '@/components/organizations/ticket-categories/TicketsCategoriesContainer.vue'
import FloorPlanContainer from '../../components/tickets/FloorPlanContainer.vue'
import TicketCreateContainer from '../../components/tickets/TicketCreateContainer.vue'
import TicketEditContainer from '../../components/tickets/TicketEditContainer.vue'
import TicketListContainer from '../../components/tickets/TicketListContainer.vue'
import GratisTicketCreateContainer from '../../components/tickets/GratisTicketCreateContainer.vue'
import AccreditationCreateContainer from './../../components/accreditations/AccreditationCreateContainer.vue'
import AccreditationUpdateContainer from './../../components/accreditations/AccreditationUpdateContainer.vue'
import AccreditationsListContainer from './../../components/accreditations/AccreditationsListContainer.vue'
import EventRequestsContainer from './../../components/accreditations/EventRequestsContainer.vue'
import InviteAttendeesContainer from './../../components/accreditations/InviteAttendeeContainer.vue'
import InviteEditContainer from './../../components/accreditations/invite/InviteEditContainer.vue'
import AnnouncementListContainer from './../../components/announcements/AnnouncementListContainer.vue'
import DisplayAnnouncement from './../../components/announcements/DisplayAnnouncement.vue'
import NewAnnouncementContainer from './../../components/announcements/NewAnnouncementContainer.vue'
import AccreditationBuilderContainer from './../../components/builder/AccreditationBuilderContainer.vue'
import EmailCreateContainer from './../../components/emails/EmailCreateContainer.vue'
import EmailDetailsContainer from './../../components/emails/EmailDetailsContainer.vue'
import EmailUpdateContainer from './../../components/emails/EmailUpdateContainer.vue'
import EmailsListContainer from './../../components/emails/EmailsListContainer.vue'
import AttendeeFieldsContainer from './../../components/events/AttendeeFieldsContainer.vue'
import EventCategoriesContainer from './../../components/events/EventCategoriesContainer.vue'
import EventConferenceDataContainer from './../../components/events/EventConferenceDataContainer.vue'
import EventCreateContainer from './../../components/events/EventCreateContainer.vue'
import EventInfoContainer from './../../components/events/EventInfoContainer.vue'
import EventUsersContainer from './../../components/events/EventUsersContainer.vue'
import EventsListContainer from './../../components/events/EventsListContainer.vue'
import TranslateContainer from './../../components/events/TranslateCotainer.vue'
import HallListContainer from './../../components/halls/HallListContainer.vue'
import NewHallContainer from './../../components/halls/NewHallContainer.vue'
import UpdateHallContainer from './../../components/halls/UpdateHallContainer.vue'
import ExportContainer from './../../components/import-export/ExportContainer.vue'
import ImportContainer from './../../components/import-export/ImportContainer.vue'
import ImportExportContainer from './../../components/import-export/ImportExportContainer.vue'
import Subscribers from './../../components/organizations/mailing-list/subscribers.vue'
import ScanEntriesContainer from './../../components/scan/ScanEntriesContainer.vue'
import OrganizerSidebar from './../../components/shared/sidebars/organizer/OrganizerSidebar.vue'
import PromoteContainer from './../../components/social/PromoteContainer.vue'
import ReferralsContainer from './../../components/social/ReferralsContainer.vue'
import ScannedTicketsContainer from './../../components/stats/scanned-tickets-container'
import VisitorStatsContainer from './../../components/stats/visitor/visitor-stats-container'
import InviteContainer from './../../components/user/InviteContainer.vue'
import OrganizerProfileContainer from './../../components/user/OrganizerProfileContainer.vue'
import TrialAccountInviteContainer from './../../components/user/TrialAccountInviteContainer.vue'
import OrganizerFinanceInfo from './../../components/user/finance-info.vue'
import OrganizationTermsOfUseForm from './../../components/organizations/organization-terms-of-use-form.vue'
import NewWorkshopContainer from './../../components/workshops/NewWorkshopContainer.vue'
import UpdateWorkshopContainer from './../../components/workshops/UpdateWorkshopContainer.vue'
import WorkShopListContainer from './../../components/workshops/WorkshopListContainer.vue'

import { mainRouteNames } from '../routeNames/mainRouteNames'
import { organizationRouteNames, organizerRouteNames } from '../routeNames/organizerRouteNames'
import { getPropsFromParams } from '../utils.routing'
import StoreSuccessfulPayment from '@/components/accreditations/organization-store/StoreSuccessfulPayment.vue'
import OrganizationReportsContainer from '@/components/organizations/reports/OrganizationReportsContainer.vue'
import FloorPlanOverview from '@/components/stats/floor-plan-overview.vue'
import CuratedInvitation from '@/components/accreditations/CuratedInvitationList.vue'
import CreateEmailInvitation from '@/components/accreditations/CreateEmailInvitation.vue'
import EmailToInvitee from '@/components/accreditations/EmailToInvitee.vue'
import DocumentationContainer from '@/components/event-documentation/DocumentationContainer.vue'
import LegalEntityInvoicesContainer from '@/components/event-documentation/LegalEntityInvoicesContainer.vue'
import EventExtraModulesContainer from '@/components/events/event-extra-modules-container.vue'

const dashboardSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/dashboard',
    props: getPropsFromParams,
    name: organizerRouteNames.eventDashboard,
    component: TicketStatistics,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Ticket statistics',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/floor-plan-overview',
    props: getPropsFromParams,
    name: organizerRouteNames.floorPlanOverview,
    component: FloorPlanOverview,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Floor plan overview',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/stats/visitors',
    props: getPropsFromParams,
    name: organizerRouteNames.visitorStatistics,
    component: VisitorStatsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Visitor statistics',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/stats/scanned',
    props: getPropsFromParams,
    name: organizerRouteNames.scannedTickets,
    component: ScannedTicketsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Scanned tickets',
    },
  },
]

const attendeeListSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/accreditations',
    props: getPropsFromParams,
    name: organizerRouteNames.accreditations,
    component: AccreditationsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendee list',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/accreditations/new',
    props: getPropsFromParams,
    name: organizerRouteNames.createAccreditation,
    component: AccreditationCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [accreditationLimitIfTrial()],
      title: 'New Accreditation',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/accreditation/:accreditationId/edit',
    props: getPropsFromParams,
    name: organizerRouteNames.editAccreditation,
    component: AccreditationUpdateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Update Accreditation',
    },
  },
]

const importExportSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/data',
    props: getPropsFromParams,
    name: organizerRouteNames.importExport,
    component: ImportExportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'What do you need?',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/data/import',
    props: getPropsFromParams,
    name: organizerRouteNames.import,
    component: ImportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Import',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/data/export',
    props: getPropsFromParams,
    name: organizerRouteNames.export,
    component: ExportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Export',
    },
  },
]

const emailsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/emails',
    props: getPropsFromParams,
    name: organizerRouteNames.emails,
    component: EmailsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Emails to attendees',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/emails/new',
    props: getPropsFromParams,
    name: organizerRouteNames.createEmail,
    component: EmailCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Create email',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/emails/:emailId/details',
    props: getPropsFromParams,
    name: organizerRouteNames.emailDetails,
    component: EmailDetailsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Email details',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/emails/:emailId/update',
    props: getPropsFromParams,
    name: organizerRouteNames.updateEmail,
    component: EmailUpdateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Update automated email',
    },
  },
]

const inviteAttendeesSidebarRoute = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/invite-attendee',
    props: getPropsFromParams,
    name: organizerRouteNames.inviteAttendee,
    component: InviteAttendeesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Invite attendees',
    },
  },
]

const pendingRequestsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/requests',
    props: getPropsFromParams,
    name: organizerRouteNames.requests,
    component: EventRequestsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendance requests',
    },
  },
]

const editInviteSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/edit-invite',
    props: getPropsFromParams,
    name: organizerRouteNames.editInvite,
    component: InviteEditContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Edit invite information',
    },
  },
]

const curatedInvitationsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/curated-invitation',
    props: getPropsFromParams,
    name: organizerRouteNames.curatedInvitations,
    component: CuratedInvitation,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Curated invitations',
    },
  },
]
const createEmailInvitationSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/email-invitation',
    props: getPropsFromParams,
    name: organizerRouteNames.createEmailInvitation,
    component: CreateEmailInvitation,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Crate e-mail invitation',
    },
  },
]
const emailToInviteesSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/email-to-invitees',
    props: getPropsFromParams,
    name: organizerRouteNames.emailsToInvitees,
    component: EmailToInvitee,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Email to invitees',
    },
  },
]

const designToolSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/builder',
    props: getPropsFromParams,
    name: organizerRouteNames.accreditationBuilder,
    component: AccreditationBuilderContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Design tool',
    },
  },
]

const documentationSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/documentation',
    props: getPropsFromParams,
    name: organizerRouteNames.eventDocumentation,
    component: DocumentationContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Documentation',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/legal-entity-invoices',
    name: organizerRouteNames.eventLegalEntityInvoices,
    props: getPropsFromParams,
    component: LegalEntityInvoicesContainer,
    meta: {
      rules: [allowedUserType(['SUPER_ADMIN', 'REGULAR'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
]

const ticketsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/tickets',
    props: getPropsFromParams,
    name: organizerRouteNames.tickets,
    component: TicketListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Tickets',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/tickets/new/:type',
    props: getPropsFromParams,
    name: organizerRouteNames.createTicket,
    component: TicketCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Create ticket',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/tickets/new-gratis',
    props: getPropsFromParams,
    name: organizerRouteNames.createGratisTicket,
    component: GratisTicketCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Create gratis ticket',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/tickets/:ticketId/edit',
    props: getPropsFromParams,
    name: organizerRouteNames.editTicket,
    component: TicketEditContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Update ticket',
    },
  },
]

const floorPlanSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/floor-plan',
    props: getPropsFromParams,
    name: organizerRouteNames.floorPlan,
    component: FloorPlanContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Floor plan',
    },
  },
]

const eventInfoSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/info',
    props: getPropsFromParams,
    name: organizerRouteNames.eventInfo,
    component: EventInfoContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Event info',
    },
  },
]

const eventExtraModulesSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/extra-modules',
    props: getPropsFromParams,
    name: organizerRouteNames.eventExtraModules,
    component: EventExtraModulesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Modules',
    },
  },
]

const translateSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/translate',
    props: getPropsFromParams,
    name: organizerRouteNames.eventTranslate,
    component: TranslateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Translate',
    },
  },
]

const usersSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/event-workers',
    props: getPropsFromParams,
    name: organizerRouteNames.eventWorkers,
    component: EventUsersContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'EventWorkers',
    },
  },
]

const categoriesSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/categories',
    props: getPropsFromParams,
    name: organizerRouteNames.eventCategories,
    component: EventCategoriesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['categoriesAndZones'])],
      title: 'Categories',
    },
  },
]

const attendeeFieldsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/attendee-fields',
    props: getPropsFromParams,
    name: organizerRouteNames.attendeeFields,
    component: AttendeeFieldsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendee fields',
    },
  },
]

const workshopsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/workshops',
    props: getPropsFromParams,
    name: organizerRouteNames.eventWorkshops,
    component: WorkShopListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['workshops', 'conferenceMobileApp'], some)],
      title: 'Workshops',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/workshops/new',
    props: getPropsFromParams,
    name: organizerRouteNames.newWorkshop,
    component: NewWorkshopContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['workshops', 'conferenceMobileApp'], some)],
      title: 'Create Workshop',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/workshops/:workshopId',
    props: getPropsFromParams,
    name: organizerRouteNames.updateWorkshop,
    component: UpdateWorkshopContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['workshops', 'conferenceMobileApp'], some)],
      title: 'Update Workshop',
    },
  },
]

const conferenceInfoSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/conference-data',
    props: getPropsFromParams,
    name: organizerRouteNames.eventConferenceData,
    component: EventConferenceDataContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['conferenceMobileApp'])],
      title: 'Event conference info',
    },
  },
]

const announcementsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/announcements',
    props: getPropsFromParams,
    name: organizerRouteNames.eventAnnouncements,
    component: AnnouncementListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['conferenceMobileApp'])],
      title: 'Announcements',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/announcements/new',
    props: getPropsFromParams,
    name: organizerRouteNames.newAnnouncement,
    component: NewAnnouncementContainer,

    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['conferenceMobileApp'])],
      title: 'Create announcements',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/announcements/:id',
    props: getPropsFromParams,
    name: organizerRouteNames.displayAnnouncement,
    component: DisplayAnnouncement,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['conferenceMobileApp'])],
      title: 'Announcement',
    },
  },
]

const hallsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/halls',
    props: getPropsFromParams,
    name: organizerRouteNames.eventHalls,
    component: HallListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['conferenceMobileApp'])],
      title: 'Halls',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/halls/new',
    props: getPropsFromParams,
    name: organizerRouteNames.newHall,
    component: NewHallContainer,

    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['conferenceMobileApp'])],
      title: 'Create hall',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/halls/:hallId',
    props: getPropsFromParams,
    name: organizerRouteNames.updateHall,
    component: UpdateHallContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['conferenceMobileApp'])],
      title: 'Hall',
    },
  },
]

const promoteSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/promote',
    props: getPropsFromParams,
    name: organizerRouteNames.promoteEvent,
    component: PromoteContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Promote',
    },
  },
]

const referralSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/referral',
    props: getPropsFromParams,
    name: organizerRouteNames.referrals,
    component: ReferralsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
]

const organizationEventsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/live-events',
    name: organizationRouteNames.liveEvents,
    props: getPropsFromParams,
    component: OrganizationLiveEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Live events',
    },
  },
  {
    path: '/organizations/:organizationSlug/past-events',
    name: organizationRouteNames.pastEvents,
    props: getPropsFromParams,
    component: OrganizationPastEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Past events',
    },
  },
]

const organizationInfoSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/organization-info',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationProfileInfo,
    component: OrganizerProfileContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Organization info',
    },
  },
]

const financeInfoSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/finance-info',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationFinanceInfo,
    component: OrganizerFinanceInfo,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Finance info',
    },
  },
]

const contractsAndTermsSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/contracts-and-terms',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationContractsAndTerms,
    component: OrganizationTermsOfUseForm,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Contracts and terms of use',
    },
  },
]

const ticketCategoriesSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/ticket-categories',
    props: getPropsFromParams,
    name: organizationRouteNames.ticketCategories,
    component: TicketsCategoriesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Ticket categories',
    },
  },
]

const subscribersSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/subscribers',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationSubscribers,
    component: Subscribers,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Subscribers',
    },
  },
  {
    path: '/organizations/:organizationSlug/messages',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationMessages,
    component: Messages,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'Messages',
    },
  },
]

const organizationUsersSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/organization-users',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationUsers,
    component: OrganizationUsers,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
      title: 'OrganizationUsers',
    },
  },
]

const organizationPromoCodesSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/promo-codes',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationPromoCodes,
    component: PromoCodesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Promo codes',
    },
  },
  {
    path: '/organizations/:organizationSlug/promo-codes/:promoCodeId',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationPromoCodeInfo,
    component: PromoCodeInfoContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Promo code',
    },
  },
]

// const couponsSidebarRoutes = [
//   {
//     path: '/organizations/:organizationSlug/loyalty-coupons',
//     props: getPropsFromParams,
//     name: organizationRouteNames.organizationLoyaltyCoupons,
//     component: OrganizerLoyaltyCoupons,
//     meta: {
//       requiresAuthentication: true,
//       redirectIfAuthenticated: false,
//       rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
//       title: 'Loyalty Coupons',
//     },
//   },
// ]

const organizationSidebarRoutes = [
  ...organizationEventsSidebarRoutes,
  ...organizationInfoSidebarRoutes,
  ...financeInfoSidebarRoutes,
  ...contractsAndTermsSidebarRoutes,
  ...subscribersSidebarRoutes,
  ...organizationUsersSidebarRoutes,
  ...organizationPromoCodesSidebarRoutes,
  ...ticketCategoriesSidebarRoutes,
  // ...couponsSidebarRoutes,
]

const scanEntriesSidebarRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/scan-entries',
    props: getPropsFromParams,
    name: organizerRouteNames.scanEntries,
    component: ScanEntriesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['scanEntries'])],
    },
  },
]

const organizerSidebarRoutes = [
  ...dashboardSidebarRoutes,
  ...attendeeListSidebarRoutes,
  ...importExportSidebarRoutes,
  ...emailsSidebarRoutes,
  ...inviteAttendeesSidebarRoute,
  ...pendingRequestsSidebarRoutes,
  ...editInviteSidebarRoutes,
  ...curatedInvitationsSidebarRoutes,
  ...createEmailInvitationSidebarRoutes,
  ...emailToInviteesSidebarRoutes,
  ...designToolSidebarRoutes,
  ...documentationSidebarRoutes,
  ...ticketsSidebarRoutes,
  ...eventInfoSidebarRoutes,
  ...eventExtraModulesSidebarRoutes,
  ...usersSidebarRoutes,
  ...categoriesSidebarRoutes,
  ...workshopsSidebarRoutes,
  ...attendeeFieldsSidebarRoutes,
  ...conferenceInfoSidebarRoutes,
  ...announcementsSidebarRoutes,
  ...hallsSidebarRoutes,
  ...floorPlanSidebarRoutes,
  ...translateSidebarRoutes,
  ...promoteSidebarRoutes,
  ...referralSidebarRoutes,
  ...scanEntriesSidebarRoutes,
]

const nonSidebarRoutes = [
  {
    path: '/events',
    name: organizerRouteNames.events,
    props: getPropsFromParams,
    component: EventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['EVENT_WORKER'])],
    },
  },
  {
    path: '/',
    name: organizerRouteNames.organizations,
    props: getPropsFromParams,
    component: OrganizationsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/organizations/new',
    name: organizerRouteNames.createOrganization,
    component: OrganizationCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/organizations/:organizationSlug/events/new',
    name: organizationRouteNames.organizationAddEvent,
    props: getPropsFromParams,
    component: EventCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [eventQuota(), allowedUserType(['REGULAR', 'TRIAL', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/invite/:inviteToken',
    name: organizerRouteNames.invite,
    component: InviteContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
    props: getPropsFromParams,
  },
  {
    path: '/create-trial-account',
    props: getPropsFromParams,
    name: organizerRouteNames.createTrialAccount,
    component: TrialAccountInviteContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: organizerRouteNames.successfulPayment,
    component: SuccessfulPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/store-successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: organizerRouteNames.storeSuccessfulPayment,
    component: StoreSuccessfulPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/custom-successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: organizerRouteNames.customSuccessfulPayment,
    component: CustomSuccessfulPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/organizations/:organizationSlug/reports',
    props: getPropsFromParams,
    name: organizationRouteNames.organizationReports,
    component: OrganizationReportsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Reports',
    },
  },
]

export const OrganizerRoutes = [
  ...nonSidebarRoutes,
  {
    path: '/organizations/:organizationSlug/events/:eventId',
    redirect: { name: organizerRouteNames.eventDashboard },
    name: mainRouteNames.organizerSidebar,
    props: getPropsFromParams,
    component: OrganizerSidebar,
    meta: {
      requiresAuthentication: true,
      requiresAuthorization: true,
      redirectIfAuthenticated: false,
    },
    children: organizerSidebarRoutes,
  },
  {
    path: '/organizations/:organizationSlug',
    redirect: { name: organizationRouteNames.liveEvents },
    name: mainRouteNames.organizationSidebar,
    props: getPropsFromParams,
    component: organizationSidebar,
    meta: {
      requiresAuthentication: true,
      requiresAuthorization: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['TRIAL', 'REGULAR', 'SUPER_ADMIN'])],
    },
    children: organizationSidebarRoutes,
  },
]
